import { useLocation } from "react-router-dom";

export default function useRegionPath():string{
    return useLocation().pathname.split("/")[1]
}